module.exports = __webpack_public_path__ + "img/Sad_icon.0b5c65ca.png";